import React from 'react';
import { Bot, FileText, TestTube2, MessageSquare, Rocket } from 'lucide-react';
import useScrollFadeIn from '../hooks/useScrollFadeIn';

const gradientText = {
  background: 'linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

const steps = [
  { icon: Bot, label: 'Name Your Assistant', number: '1' },
  { icon: FileText, label: 'Upload Business Knowledge', number: '2' },
  { icon: TestTube2, label: 'Test Locally', number: '3' },
  { icon: MessageSquare, label: 'Connect WhatsApp', number: '4' },
  { icon: Rocket, label: 'Go Live', number: '5' },
];

export default function Solution() {
  const { ref, isVisible } = useScrollFadeIn();

  return (
    <section id="solution" className="py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
      <div
        ref={ref}
        className={`max-w-6xl mx-auto transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Section heading */}
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4" style={{ color: 'var(--text-heading)' }}>
            Meet <span style={gradientText}>Botibonga Studio</span>
          </h2>
          <p className="text-base sm:text-lg max-w-2xl mx-auto" style={{ color: 'var(--text-body)' }}>
            Your no code platform to create, train, and deploy AI customer service assistants for WhatsApp.
            Built for non technical users. Takes only minutes to set up.
          </p>
        </div>

        {/* Step flow */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <React.Fragment key={index}>
                {/* Step card */}
                <div
                  className="flex flex-col items-center text-center w-full md:w-40 rounded-2xl p-4 transition-all duration-300 hover:-translate-y-1"
                  style={{
                    background: 'var(--bg-card)',
                    border: '1px solid var(--border-card)',
                    boxShadow: 'var(--shadow-card)',
                    backdropFilter: 'blur(var(--glass-blur))',
                    WebkitBackdropFilter: 'blur(var(--glass-blur))',
                  }}
                >
                  <div
                    className="w-8 h-8 rounded-full text-white text-sm font-bold flex items-center justify-center mb-3"
                    style={{ background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' }}
                  >
                    {step.number}
                  </div>
                  <div
                    className="w-14 h-14 rounded-xl flex items-center justify-center mb-3"
                    style={{ background: 'var(--bg-icon)' }}
                  >
                    <Icon className="w-7 h-7" style={{ color: 'var(--text-accent)' }} />
                  </div>
                  <p className="text-sm font-medium" style={{ color: 'var(--text-heading)' }}>
                    {step.label}
                  </p>
                </div>

                {/* Connector line (not after last step) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block flex-1 mx-2">
                    <div
                      className="h-0 w-full"
                      style={{ borderTop: '2px dashed #c7d2fe' }}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
}
